import React, { useState } from "react";
// import Alert from "react-s-alert";
import { saveAuthentication,  saveUserInfo, userInfo } from "../CookiesUtil";
import { getCurrentUser, RequestOpenAxios, signup } from "../APIUtils";
import { WarningAlert } from "src/components/tool/Alerts";
import { useDispatch } from "react-redux";
import { login } from "src/store/reducers/authSlice";

type SignUpFormProps = {
//   modifyAccess: (access: { authenticated: boolean; user: any; aci: any }) => void;
onLogin: (userData: { email: string; name: string }) => void;
};

type User = {
  name: string;
  familyName: string;
  givenName: string;
  email: string;
  password: string;
  signUpCode: string;
  websiteId?: string;
};

const SignUpForm: React.FC<SignUpFormProps> = ({ onLogin }) => {
  const [useremail, setUseremail] = useState<string>("");
  const [signupbtn, setSignupbtn] = useState<boolean>(false);
  const [requestbtn, setRequestbtn] = useState<boolean>(false);
  const [requestsent, setRequestsent] = useState<boolean>(false);
  const [amsg, setAmsg] = useState<string>("Enter your email:");

  const dispatch = useDispatch();

  const handleRequestemailsignupcode = async (event: React.FormEvent) => {
    event.preventDefault();
    setRequestbtn(true);
    const newEmail = (document.getElementById("newEmail") as HTMLInputElement).value;

    try {
      const res = await RequestOpenAxios({
        url: "/auth/requestemailsignupcode",
        method: "POST",
        params: { newEmail, websiteId: "xnews" },
      });

      if (!res.data.success) {
        // Alert.error(res.data.message);
        setAmsg(res.data.message);
        setRequestbtn(false);
        return;
      }

      setRequestsent(true);
      setUseremail(newEmail);
      setAmsg("A verification code has been sent to your email");
    } catch (error) {
        // Alert.error((error as Error).message);
      setRequestbtn(false);
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSignupbtn(true);

    const myUser: User = {
      familyName: (document.getElementById("firstName") as HTMLInputElement).value,
      givenName: (document.getElementById("lastName") as HTMLInputElement).value,
      email: useremail,
      password: (document.getElementById("password") as HTMLInputElement).value,
      signUpCode: (document.getElementById("signUpCode") as HTMLInputElement).value,
      name: "",
      websiteId: "xnews",
    };
    myUser.name = `${myUser.familyName} ${myUser.givenName}`;

    if (myUser.name.trim().length < 1) {
      setAmsg("Please enter a name");
      // Alert.error("Please enter a name", { timeout: 3000 });
      setSignupbtn(false);
      return;
    }

    if (myUser.password.length < 8) {
      setAmsg("Password needs to be at least 8 characters");
      // Alert.error("Password needs to be at least 8 characters", { timeout: 3000 });
      setSignupbtn(false);
      return;
    }

    if (myUser.signUpCode.length < 8) {
      setAmsg("Verification code is incorrect! Check your email.");
      // Alert.error("Verification code is incorrect, check your email", { timeout: 3000 });
      setSignupbtn(false);
      return;
    }

    try {
      const response = await signup(myUser);
      if (!response.standardResponse.success) {
        // Alert.error(response.standardResponse.message, { timeout: 3000 });
        setAmsg(response.standardResponse.message);
        setSignupbtn(false);
        return;
      }

      saveAuthentication(response.accessToken);
      const successMsg = "<h5>Registration Success!<h5>";

      const res = await getCurrentUser();
      if (res) {
        saveUserInfo(res);
        // modifyAccess({ authenticated: isAuthenticated(), user: userInfo(), aci: res.aci });

        dispatch(login(userInfo()));
        onLogin(myUser);

        setAmsg(successMsg);
        // Alert.success(successMsg, { timeout: "none", offset: 150, html: true });
      }
    } catch (error) {
        // Alert.error((error as Error).message);
    } finally {
      setSignupbtn(false);
    }
  };

  return (
    <div>
      <WarningAlert displayAlert={true} alertMessage={amsg} />
      {!requestsent ? (
        <form onSubmit={handleRequestemailsignupcode}>
          <div className="form-item">
            <input type="email" id="newEmail" className="form-control mt-2 mb-2" placeholder="Enter your email" required />
          </div>
          <button type="submit" disabled={requestbtn} className="btn btn-block btn-primary mt-2 mb-2">
            Request Email Registration Code
          </button>
        </form>
      ) : (
        <form className="form-group">
          <div className="form-item">
            <input type="email" id="email" className="form-control mt-2 mb-2" placeholder={useremail} readOnly required />
          </div>
          <div className="form-item">
            <input type="text" id="signUpCode" className="form-control mt-2 mb-2" placeholder="Email verification Code" required />
          </div>
          <div className="form-item">
            <input type="text" id="firstName" className="form-control mt-2 mb-2" placeholder="First Name" required />
          </div>
          <div className="form-item">
            <input type="text" id="lastName" className="form-control mt-2 mb-2" placeholder="Last Name" required />
          </div>
          <div className="form-item">
            <input type="password" id="password" className="form-control mt-2 mb-2" placeholder="Password" required />
          </div>
          <button type="button" disabled={signupbtn} onClick={handleSubmit} className="btn btn-block btn-primary mt-2 mb-2">
            Sign Up
          </button>
        </form>
      )}
    </div>
  );
};

export default SignUpForm;
